let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Vadv")).then(() => parcelRequire('9jIg7'));